import styled from "styled-components";

export const Container = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: 0.15fr 1fr;
	grid-column-gap: 10px;
`;

export const AreaCurrentImage = styled.div`
	> img {
		width: 100%;
		max-width: 100%;
		max-height: 500px;
		min-width: 100%;
		min-height: 500px;
		object-fit: contain;
		cursor: zoom-in !important;
	}
`;

export const AreaPreviewImage = styled.div`
	display: flex;
	flex-direction: column;
	cursor: pointer;
	gap: 25px;
	justify-content: start;
	padding-top: 20px;

	> img {
		width: 100%;
		max-width: 50px;
		max-height: 50px;
		min-width: 50px;
		min-height: 50px;
		object-fit: contain;
	}
`;
